export const topics = [
  {
    slug: 'industry-secret',
    name: '行业黑幕',
    icon: 'ri-eye-off-line',
    desc: '深入供应链与产业链，还原那些写在合同背面、却影响每个消费者的行业规则。',
    count: 286,
    keywords: ['供应链', '潜规则', '成本结构'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20illustration%20of%20a%20factory%20silhouette%20behind%20layered%20paper%20sheets%2C%20crimson%20and%20amber%20accents%20on%20deep%20charcoal%20background%2C%20minimal%20geometric%20style%2C%20no%20text&width=800&height=600&seq=baoliao-topic-industry&orientation=landscape',
  },
  {
    slug: 'brand-meltdown',
    name: '品牌翻车',
    icon: 'ri-alarm-warning-line',
    desc: '按时间线记录品牌口碑崩塌的全过程，以及事发之后到底做了什么补救。',
    count: 214,
    keywords: ['口碑', '公关回应', '后续处理'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20cracked%20geometric%20badge%20shape%20on%20deep%20charcoal%20paper%2C%20crimson%20and%20amber%20highlights%2C%20minimal%20flat%20style%2C%20no%20text&width=800&height=600&seq=baoliao-topic-brand&orientation=landscape',
  },
  {
    slug: 'star-story',
    name: '明星八卦',
    icon: 'ri-star-smile-line',
    desc: '娱乐圈动态与幕后故事，只讲有时间线、有信源的公开信息。',
    count: 342,
    keywords: ['时间线', '信源', '公开信息'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20glowing%20stage%20spotlight%20beam%20over%20empty%20dark%20space%2C%20amber%20and%20crimson%20glow%2C%20minimal%20geometric%20style%2C%20no%20text&width=800&height=600&seq=baoliao-topic-star&orientation=landscape',
  },
  {
    slug: 'product-test',
    name: '产品测评',
    icon: 'ri-focus-3-line',
    desc: '实拍实测与横向对比，用数据说明宣传页面上的那句话到底成不成立。',
    count: 268,
    keywords: ['实测', '对比', '数据'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20stacked%20measurement%20cards%20and%20grid%20lines%20on%20deep%20charcoal%20surface%2C%20amber%20and%20crimson%20details%2C%20minimal%20flat%20style%2C%20no%20text&width=800&height=600&seq=baoliao-topic-test&orientation=landscape',
  },
  {
    slug: 'rights-case',
    name: '维权案例',
    icon: 'ri-scales-3-line',
    desc: '复盘真实维权过程：从保留证据到沟通升级，每一步都给出可复用的经验。',
    count: 396,
    keywords: ['证据', '投诉路径', '经验'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20balanced%20scales%20made%20of%20paper%20fold%20on%20deep%20charcoal%20background%2C%20crimson%20and%20amber%20accents%2C%20minimal%20flat%20style%2C%20no%20text&width=800&height=600&seq=baoliao-topic-rights&orientation=landscape',
  },
  {
    slug: 'deep-report',
    name: '深度调查',
    icon: 'ri-search-eye-line',
    desc: '长周期追踪报道，多信源交叉核实，把一件事的来龙去脉讲完整。',
    count: 158,
    keywords: ['长周期', '多信源', '交叉核实'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20concentric%20radar%20rings%20and%20document%20sheets%20on%20deep%20charcoal%20paper%2C%20amber%20and%20crimson%20tones%2C%20minimal%20flat%20style%2C%20no%20text&width=800&height=600&seq=baoliao-topic-deep&orientation=landscape',
  },
];